import { RefObject, useCallback, useRef } from 'react';

export const useFocusOnStep = (): {
  containerRef: RefObject<HTMLDivElement | null>;
  focusHeading: () => void;
} => {
  const containerRef = useRef<HTMLDivElement>(null);

  const focusHeading = useCallback(() => {
    const heading = containerRef.current?.querySelector<HTMLElement>(
      '[data-step-heading]',
    );
    if (!heading) return;

    const active = document.activeElement;
    const container = containerRef.current;
    // Only move focus if the user hasn't already focused something inside
    // this container (e.g. tapped an input during the slide transition).
    const userFocusedInsideContainer =
      container &&
      active !== document.body &&
      active !== heading &&
      container.contains(active);

    if (!userFocusedInsideContainer) {
      heading.focus();
    }
  }, []);

  return { containerRef, focusHeading };
};
